export default __webpack_public_path__ + "static/media/Bmw1.f3956c51.jpg";